import React from 'react'

import { displayRowProps } from '../../utils'
import * as s from './Rows.module.scss'

interface IRowsProps {
  children?: React.ReactNode | ((props: { index: number }) => React.ReactNode)
  nodeId?: string
  rows?: number
  gap?: number
}

const Rows: React.FC<IRowsProps> = ({ children, nodeId, rows, gap }) => {
  return (
    <>
      {Array.from({ length: rows || 1 }, (_i, i) => i + 1).map((row) => (
        <div
          {...displayRowProps(nodeId, row)}
          className={s.row}
          key={`row:${row}`}
          style={{
            gridArea: `${row} / ${1} / ${row + 1} / ${-1}`,
            height: `calc(100% + ${row !== rows ? gap || 0 : 0}px)`,
          }}
        >
          <div
            className={s.content}
            style={{ height: `calc(100% - ${row !== rows ? gap || 0 : 0}px)` }}
          >
            {typeof children == 'function' ? children({ index: row - 1 }) : children}
          </div>
        </div>
      ))}
    </>
  )
}

export default React.memo(Rows)
